<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="7" sm="12" class="mt-2">
          <p class="reg-heading-tab">Lending Loan Application</p>
          <p></p>
          <div class="reg-tab-container">
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Loan Application District*"
              label-size="sm"
              label-cols="4"
              label-for="exampleInput2"
            >
              <b-form-select
                id="exampleInput2"
                :options="districts"
                value-field="DistID"
                text-field="DistName"
                required
                size="sm"
                v-model="form.UserLendingLoanDetails.LoanDistrict"
                disabled
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="igrp1"
              horizontal
              label="Name of the project/Business"
              label-cols="4"
              label-size="sm"
            >
              <b-form-input
                type="text"
                placeholder="Name of the Project/Business*"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.UserLendingLoanDetails.OrganizationName"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="igrp2"
              horizontal
              label="Final Products"
              label-cols="4"
              label-size="sm"
            >
              <b-form-input
                type="text"
                placeholder="Final Products"
                size="sm"
                :formatter="format"
                required
                lazy-formatter
                v-model="form.UserLendingLoanDetails.ProductfromOrganization"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="igrp3"
              horizontal
              label="Organization Address*"
              label-cols="4"
              label-size="sm"
            >
              <b-form-input
                type="text"
                placeholder="Organization Address"
                size="sm"
                required
                :formatter="format"
                lazy-formatter
                v-model="form.UserLendingLoanDetails.OrganizationAddress"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Amount required from Bank*"
              label-cols="4"
              label-size="sm"
              label-for="inpAmountBank"
            >
              <b-form-input
                id="inpAmountBank"
                type="number"
                v-model="form.UserLendingLoanDetails.AmountFromBank"
                required
                size="sm"
                :min="minAmount"
                :max="maxAmount"
                placeholder="Amount required from Bank"
              ></b-form-input>
              <small class="text-muted">
                Min: ₹{{ (minAmount/100000).toFixed(0) }} Lakh &nbsp;|&nbsp;
                Max: ₹{{ (maxAmount/100000).toFixed(0) }} Lakh
              </small>

          
            </b-form-group>
            <!-- <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Bank Name*" label-cols="4"
              label-size="sm"
              label-for="inpBank"
            >
              <b-form-input
                id="inpBank"
                type="text"
                v-model="form.UserLendingLoanDetails.BankName"
                required
                size="sm"
                placeholder="Name of the Bank"
              ></b-form-input>
            </b-form-group>-->
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Bank Name*"
              label-size="sm"
              label-for="inpbankName"
            >
              <b-form-select
                id="inpbankName"
                :options="Banks"
                value-field="BankName"
                text-field="BankName"
                required
                size="sm"
                @change.native="filterBranches"
                v-model="form.UserLendingLoanDetails.BankName"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Branch Name*"
              label-cols="4"
              label-size="sm"
              label-for="inpBranch"
            >
              <b-form-input
                id="inpBranch"
                type="text"
                v-model="form.UserLendingLoanDetails.Branch"
                required
                size="sm"
                placeholder="Branch Name"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 justify-content-md-center" v-if="!getUserData.LockProfile">
        <b-col md="4" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align:right">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
export default {
  components: { Spinner },
  data() {
    return {
      show: true,
      isAdrsSame: false,
      minAmount: 100000,
      maxAmount: 1500000,
      minAmountEd:100000,
      maxAmountEd:2000000,
      Banks: [],
      form: {
        UserLendingLoanDetails: {
          OrganizationName: "",
          ProductfromOrganization: "",
          OrganizationAddress: "",
          AmountFromBank: "",
          LoanDistrict: "",
          BankName: "",
          Branch: ""
        },
        LoginID: ""
      },
      districts: [],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      saved: false
    };
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },

    onSubmit(evt) {
      evt.preventDefault();
      if (
        this.form.UserLendingLoanDetails.LoanDistrict == "" ||
        this.form.UserLendingLoanDetails.LoanDistrict ==
          "00000000-0000-0000-0000-000000000000"
      ) {
        this.alertText = "Please Complete your Correspondance Address";
        this.showDismissibleAlert = true;
        this.variant = "danger";
        return;
      }
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.saveLendingLoanDetails(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.$store.dispatch(
              "setLoanDistrict",
              this.form.UserLendingLoanDetails.LoanDistrict
            );
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.Banks = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    filterDistricts() {},
    filterTalukas() {},
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getUserLendingLoanDetails() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadUserLendingLoanDetails(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.form.UserLendingLoanDetails = response.body;
            this.$store.dispatch(
              "setLoanDistrict",
              this.form.UserLendingLoanDetails.LoanDistrict
            );
            //alert(this.form.UserLendingLoanDetails.LoanDistrict);
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  computed: {
    getUserData() {
      let x = this.$store.getters.getUserData;
      let OrganizationName = "";
      let ProductfromOrganization = "";
      let OrganizationAddress = "";
      let AmountFromBank = 0;

      return {
        LockProfile: x.LockProfile
      };
    }
  },
  watch: {
    "$store.state.loanDistrict": function() {
      this.form.UserLendingLoanDetails.LoanDistrict = this.$store.state.loanDistrict;
    }
  },
  mounted() {
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.ReadBanks();
    if (this.$store.getters.isLoggedIn) {
      this.getUserLendingLoanDetails();
      // getScheme.LoanType is set when a scheme is selected (2=Group, 1=Individual).
      // getLoanType (state.LoanType) defaults to 1 so check scheme first.
      let schemeType = this.$store.getters.getScheme && this.$store.getters.getScheme.LoanType;
      let loanType = schemeType || this.$store.getters.getLoanType || 1;
      
      if (loanType == 2 || loanType == "2") {
        this.minAmount = 1000000;
        this.maxAmount = 3000000;
      }
      if (loanType == 3 || loanType == "3") {
        
        this.minAmount = 100000;
        this.maxAmount = 2000000;
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/LendingLoan.vue